import { uploadFileToS3 } from './upload-file-to-s3'

export const awsS3Api = {
  uploadFileToS3: uploadFileToS3,
}
